import React, { useState, useEffect, useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin,
} from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  PlusCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../customer.config";
import styles from "../../../assets/styles/styles";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { TextArea } = Input;

const NewCustomer = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [form] = Form.useForm();
  const isActive = Form.useWatch("active", form);
  const idType = Form.useWatch("idTypeId", form);
  const openCasa = Form.useWatch("openCasa", form);
  const legalOption = Form.useWatch("legalFormId", form);
  const isStaff = Form.useWatch("isStaff", form);
  const dispatch = useDispatch();
  const [officeData, setOfficeData] = useState([]);
  const [legalFormData, setLegalFormData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [titleData, setTitleData] = useState([]);
  const [savingsProduct, setSavingsProduct] = useState([]);
  const [activationDate, setActivationDate] = useState([]);
  const [clientClassificationData, setClientClassificationData] = useState([]);
  const [
    clientNonPersonConstitutionOptions,
    setClientNonPersonConstitutionOptions,
  ] = useState([]);
  const [
    clientNonPersonMainBusinessLineOptions,
    setClientNonPersonMainBusinessLineOptions,
  ] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [identifactionTypeData, setIdentificattionTypeData] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [isAddressEnabled, setIsAddressEnabled] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [serviceProviderList, setServiceProviderList] = useState([]);
  const [formData, setFormData] = useState({
    customerInfo: null,
    customerAddressInfo: null,
  });

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };

  const minDate = dayjs().add(0, "day");

  const disableDaysBeforeToday = useCallback(
    (current) => {
      if (current == null) {
        return null;
      }

      return (
        minDate != null &&
        current.isBefore(minDate) &&
        !current.isSame(minDate, "day")
      );
    },
    [minDate],
  );

  useEffect(() => {
    getTemplate();
    getAddress();
    getServiceProviderListAction();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Clients}/template?staffInSelectedOfficeOnly=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        setIsAddressEnabled(objList.isAddressEnabled);

        let tempOfficeData = [];
        let tempLegalFormData = [];
        let tempCustomerType = [];
        let tempTitle = [];
        let tempCountries = [];
        let tempCountryId = [];
        let tempAddressTypeId = [];
        let tempStateProvinceId = [];
        let tempGender = [];
        let tempIdentification = [];
        let tempClientClassification = [];
        let tempClientNonPersonConstitutionOptions = [];
        let tempClientNonPersonMainBusinessLineOptions = [];
        let tempStaffData = [];
        let tempSavingsProduct = [];

        objList?.officeOptions?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.clientLegalFormOptions?.forEach((element) => {
          tempLegalFormData.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.clientTypeOptions?.forEach((element) => {
          tempCustomerType.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.genderOptions?.forEach((element) => {
          tempGender.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.countryOptions?.forEach((element) => {
          tempCountries.push({
            value: element.description,
            label: element.name,
          });
        });

        objList?.clientClassificationOptions?.forEach((element) => {
          tempClientClassification.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.clientNonPersonConstitutionOptions?.forEach((element) => {
          tempClientNonPersonConstitutionOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.clientNonPersonMainBusinessLineOptions?.forEach((element) => {
          tempClientNonPersonMainBusinessLineOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.staffOptions?.forEach((element) => {
          tempStaffData.push({
            value: element.id,
            label: element.displayName,
          });
        });
        objList?.savingProductOptions
          ?.filter((item) => item.allowOverdraft === false)
          .forEach((element) => {
            tempSavingsProduct.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        objList?.idTypes?.forEach((element) => {
          tempIdentification.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.address[0]?.countryIdOptions.forEach((element) => {
          tempCountryId.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.address[0]?.stateProvinceIdOptions.forEach((element) => {
          tempStateProvinceId.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.address[0]?.addressTypeIdOptions.forEach((element) => {
          tempAddressTypeId.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);
        setLegalFormData(tempLegalFormData);
        setCustomerTypeData(tempCustomerType);
        setTitleData(tempTitle);
        setSavingsProduct(tempSavingsProduct);
        // setActivationDate(dayjs(tempActivationDate));
        setClientClassificationData(tempClientClassification);
        setClientNonPersonConstitutionOptions(
          tempClientNonPersonConstitutionOptions,
        );
        setClientNonPersonMainBusinessLineOptions(
          tempClientNonPersonMainBusinessLineOptions,
        );
        setStaffData(tempStaffData);
        setCountryData(tempCountries);
        setCountryIdData(tempCountryId);
        setAddressTypeIdData(tempAddressTypeId);
        setStateProvinceIdData(tempStateProvinceId);
        setGenderData(tempGender);
        setIdentificattionTypeData(tempIdentification);
        setIsLoading(false);
      }
    });
  }

  function getAddress() {
    const url = `${apiConfig.FieldConfiguration}/ADDRESS`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        // const objList = res;
      }
    });
  }
  const getServiceProviderListAction = (offset = 0) => {
    setIsLoading(true);
    // setIsSearch(false);

    const body = {
      session,
      params: {
        // limit: pageSize,
        offset,
        orderBy: "id",
        agentMerchantOnly: true,
      },
    };

    BOM.FetchReqAction(body, apiConfig.Clients, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        return;
      }

      const tempArray = res.pageItems.map((element) => {
        return {
          key: element?.agentMerchantData?.id,
          value: element?.agentMerchantData?.id,
          name: element?.agentMerchantData?.displayName || "-",
          label: element?.agentMerchantData?.agentCode || "-",
          // agentId: element?.agentMerchantData?.agentCode || "-",
        };
      });

      setServiceProviderList(tempArray);
      setIsLoading(false);
    });
  };

  function onCancel() {
    navigate("/cst0100", { replace: false });
  }

  const handleAddressDelete = (key) => {
    // console.log(key);
    let action = "Delete  ";
    let label = key.title;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = addressList.filter((item) => item.id !== key.id);
        setAddressList(newData);
      },

      function () {
        // No button
      },
    );
  };

  const onSubmit = (formValues) => {
    console.log(formValues);

    formValues.dateOfBirth = formValues.dateOfBirth
      ? BOM.DateTime(formValues.dateOfBirth, "only-date")
      : formValues.dateOfBirth;
    formValues.dateOfIncorporation = formValues.dateOfIncorporation
      ? BOM.DateTime(formValues.dateOfIncorporation, "only-date")
      : formValues.dateOfIncorporation;
    formValues.activationDate = formValues.activationDate
      ? BOM.DateTime(formValues.activationDate, "only-date")
      : formValues.activationDate;
    formValues.submittedOnDate = formValues.submittedOnDate
      ? BOM.DateTime(formValues.submittedOnDate, "only-date")
      : formValues.submittedOnDate;
    formValues.idIssuingDate = formValues.idIssuingDate
      ? BOM.DateTime(formValues.idIssuingDate, "only-date")
      : formValues.idIssuingDate;
    formValues.passExpDate = formValues.passExpDate
      ? BOM.DateTime(formValues.passExpDate, "only-date")
      : formValues.passExpDate;

    formValues.clientNonPersonDetails = {
      constitutionId: formValues.constitutionId,
      dateFormat: "dd MMMM yyyy",
      incorpNumber: formValues.incorpNumber,
      incorpValidityTillDate: formValues.incorpValidityTillDate
        ? BOM.DateTime(formValues.incorpValidityTillDate, "only-date")
        : formValues.incorpValidityTillDate,
      locale: "en",
      mainBusinessLineId: formValues.mainBusinessLineId,
      remarks: formValues.remarks,
    };

    formValues.address = addressList;

    formValues.address?.forEach((element) => {
      delete element.id;
      delete element.description;
      delete element.title;
    });
    delete formValues.openCasa;
    delete formValues.constitutionId;
    delete formValues.incorpNumber;
    delete formValues.incorpValidityTillDate;
    delete formValues.mainBusinessLineId;
    delete formValues.remarks;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      // agentCustomerId: formValues.agentCustomerId,
      method: "POST",
      session,
    };
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.Clients,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newCustomerMsg);
          navigate("/cst0100");
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/cst0100");
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.newCustomer}
        pageItems={staticConfig.newBreadcrumbItems}
      />
      <Card
        headStyle={{ borderBottomWidth: 0 }}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Row>
          <Form
            initialValues={{
              active: false,
              isStaff: false,
              openCasa: false,
            }}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
            name="customer-info"
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.customerSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.generalInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.customerType}
                  name="clientTypeId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.customerType),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.customerType}`,
                      "select",
                    )}
                    options={customerTypeData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.legalForm}
                  name="legalFormId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.legalForm),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.legalForm}`,
                      "select",
                    )}
                    options={legalFormData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.branch}
                  name="officeId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.branch),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.branch}`,
                      "select",
                    )}
                    options={officeData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {legalOption === 2 && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.name}
                    name="fullname"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.name),
                      },
                    ]}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                    />
                  </Form.Item>
                </Col>
              )}
              {!(legalOption === 2) && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.firstName}
                      name="firstname"
                      rules={BOM.fieldRules("firstName", true)}
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.firstName,
                        )}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.middleName}
                      name="middlename"
                      rules={BOM.fieldRules("middleName", false)}
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.middleName,
                        )}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.lastName}
                      name="lastname"
                      rules={BOM.fieldRules("lastName", true)}
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.lastName,
                        )}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.dateOfBirth}
                      name="dateOfBirth"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: BOM.CheckReqFld(labelConfig.dateOfBirth, "select"),
                      //   },
                      // ]}
                      rules={[
                        // { required: true, message: "Please enter your age!" },
                        // BOM.fieldRules("only-number"),
                        {
                          validator: (_, value) => {
                            const result = BOM.validateMinimumAge(value, 18);
                            if (!result.valid) {
                              return Promise.reject(new Error(result.message));
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <DatePicker
                        // defaultValue={defaultValue}
                        disabledDate={disabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.dateOfBirth,
                          "select",
                        )}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.gender}
                      name="genderId"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(labelConfig.gender),
                        },
                      ]}
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.gender,
                          "select",
                        )}
                        options={genderData}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              {BOM.HasPermission("ACTIVATE_CLIENT") && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.status} name="active">
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.status}`,
                        "select",
                      )}
                      options={staticConfig.statusData}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              )}
              {isActive && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.activationDate}
                    name="activationDate"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.activationDate),
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={disabledAfterCurrentDate}
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.activationDate,
                        "select",
                      )}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    legalOption === 2
                      ? labelConfig.businessRegistrationNumber
                      : labelConfig.externalID
                  }
                  name="externalId"
                  rules={[
                    {
                      required: legalOption === 2 ? true : false,
                      validator(_, value) {
                        if (legalOption === 2 && !value) {
                          return Promise.reject(
                            new Error(
                              "Business Registration Number is required",
                            ),
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      legalOption === 2
                        ? labelConfig.businessRegistrationNumber
                        : labelConfig.externalID,
                    )}
                  />
                </Form.Item>
              </Col>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.contactInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.email}
                  name="emailAddress"
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.email)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.mobileNumber}
                  name="mobileNo"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.mobileNumber),
                  //   },
                  // ]}
                  rules={[
                    () => ({
                      validator(_, value) {
                        console.log(value);
                        if (!value) {
                          return Promise.reject(
                            new Error("Mobile number is required"),
                          );
                        }
                        if (value?.length !== 11) {
                          return Promise.reject(
                            new Error(
                              "Mobile number must be exactly 11 digits",
                            ),
                          );
                        }
                        if (!/^[0-9]{11}$/.test(value)) {
                          return Promise.reject(
                            new Error(
                              "Mobile number must contain only numbers",
                            ),
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.mobileNumber,
                    )}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
              {!(legalOption === 2) && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.nationality}
                      name="nationality"
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.nationality,
                          "select",
                        )}
                        options={countryData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.identifactionType}
                      name="idTypeId"
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.identifactionType,
                          "select",
                        )}
                        options={identifactionTypeData}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              {idType && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.identifactionNo}
                      name="idNo"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(labelConfig.identifactionNo),
                        },
                      ]}
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.identifactionNo,
                        )}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.issuingDate}
                      name="idIssuingDate"
                      rules={[
                        {
                          required: idType === 2 ? false : true,
                          message: BOM.CheckReqFld(labelConfig.issuingDate),
                        },
                      ]}
                    >
                      <DatePicker
                        disabledDate={disabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.issuingDate,
                          "select",
                        )}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.expiryDate}
                      name="passExpDate"
                      rules={[
                        {
                          required: idType === 2 ? false : true,
                          message: BOM.CheckReqFld(labelConfig.expiryDate),
                        },
                      ]}
                    >
                      <DatePicker
                        disabledDate={disableDaysBeforeToday}
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.expiryDate,
                          "select",
                        )}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              {legalOption === 2 && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.incorporationDate}
                      name="dateOfBirth"
                      // rules={[
                      //   {
                      //     required: idType === 2 ? false : true,
                      //     message: BOM.CheckReqFld(labelConfig.incorporationDate),
                      //   },
                      // ]}
                    >
                      <DatePicker
                        disabledDate={disabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.incorporationDate,
                          "select",
                        )}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.incorporationValidUntil}
                      name="incorpValidityTillDate"
                      // rules={[
                      //   {
                      //     required: idType === 2 ? false : true,
                      //     message: BOM.CheckReqFld(
                      //       labelConfig.incorporationValidUntil
                      //     ),
                      //   },
                      // ]}
                    >
                      <DatePicker
                        disabledDate={disableDaysBeforeToday}
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.incorporationValidDate,
                          "select",
                        )}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.taxIDNumber}
                      name="incorpNumber"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(labelConfig.taxIDNumber),
                        },
                      ]}
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.taxIDNumber,
                        )}
                        style={styles.ofInputFieldNumber}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.constitution}
                      name="constitutionId"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(labelConfig.constitution),
                        },
                      ]}
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.constitution,
                          "select",
                        )}
                        options={clientNonPersonConstitutionOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.mainBusinessLine}
                      name="mainBusinessLineId"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: BOM.CheckReqFld(labelConfig.mainBusinessLine),
                      //   },
                      // ]}
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.mainBusinessLine,
                          "select",
                        )}
                        options={clientNonPersonMainBusinessLineOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.remarks}
                      name="remarks"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: BOM.CheckReqFld(labelConfig.remarks),
                      //   },
                      // ]}
                    >
                      <TextArea
                        showCount
                        maxLength={100}
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.remarks,
                        )}
                        style={{
                          height: 120,
                          resize: "none",
                        }}
                      ></TextArea>
                    </Form.Item>
                  </Col>
                </>
              )}
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.additionalInfo}
                </Title>
              </Divider>
              {!(legalOption === 2) && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.isStaff} name="isStaff">
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.isStaff,
                        "select",
                      )}
                      options={staticConfig.yesOrNoData}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              )}
              {!isStaff && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.serviceProvider}
                    name="agentCustomerId"
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.serviceProvider,
                        "select",
                      )}
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase(),
                        )
                      }
                      options={serviceProviderList}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.customerClassification}
                  name="clientClassificationId"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.customerClassification,
                      "select",
                    )}
                    options={clientClassificationData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.openCasaAccount} name="openCasa">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.openCasaAccount,
                      "select",
                    )}
                    options={staticConfig.yesOrNoData}
                  />
                </Form.Item>
              </Col>
              {openCasa && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.selectCasaProduct}
                    name="savingsProductId"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.selectCasaProduct),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.selectCasaProduct,
                        "select",
                      )}
                      options={savingsProduct}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.submittedOn}
                  name="submittedOnDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.submittedOn),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.submittedDate,
                      "select",
                    )}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <div
                style={{
                  width: "100%",
                  padding: "16px",
                }}
              >
                <Spin spinning={isLoading} tip="Loading..." size="large">
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      {labelConfig.addressInfo}
                    </Title>
                  </Divider>

                  {BOM.HasPermission("READ_ADDRESS") && (
                    <AddressModal
                      formData={formData}
                      stateProvinceIdData={stateProvinceIdData}
                      countryIdData={countryIdData}
                      addressTypeIdData={addressTypeIdData}
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      setAddressList={setAddressList}
                      addressList={addressList}
                    />
                  )}
                  {addressList?.length > 0 && (
                    <List
                      itemLayout="horizontal"
                      dataSource={addressList}
                      renderItem={(item, index) => (
                        <Card style={{ width: "100%", marginBottom: 20 }}>
                          <List.Item
                            actions={[
                              <Button
                                type="primary"
                                danger
                                shape="round"
                                size="small"
                                onClick={() => handleAddressDelete(item)}
                                icon={<DeleteOutlined />}
                                style={{
                                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                  marginLeft: "auto",
                                }}
                              >
                                Remove
                              </Button>,
                            ]}
                          >
                            <List.Item.Meta
                              title={item.title}
                              description={item.description}
                            />
                          </List.Item>
                        </Card>
                      )}
                    />
                  )}
                </Spin>
              </div>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_CLIENT") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                  isLoading={isLoading}
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Row>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewCustomer);

const AddressModal = (props) => {
  const {
    stateProvinceIdData,
    formData,
    countryIdData,
    addressTypeIdData,
    isModalOpen,
    setIsModalOpen,
    setAddressList,
    addressList,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleAddressSave = (formValues) => {
    const addressType = addressTypeIdData?.find(
      (item) => item.value === formValues.addressTypeId,
    );
    const stateProvince = stateProvinceIdData?.find(
      (item) => item.value === formValues.stateProvinceId,
    );
    const country = countryIdData?.find(
      (item) => item.value === formValues.countryId,
    );

    const newAddress = {
      id: formValues?.addressTypeId,
      title: addressType?.label,
      description: `${formValues?.addressLine1}, ${formValues?.city}, ${stateProvince?.label}, ${country?.label}, ${formValues?.postalCode}`,
      addressLine1: formValues?.addressLine1,
      addressLine2: formValues?.addressLine2,
      addressTypeId: formValues?.addressTypeId,
      city: formValues?.city,
      countryId: formValues?.countryId,
      isActive: formValues?.isActive,
      postalCode: formValues?.postalCode,
      stateProvinceId: formValues?.stateProvinceId,
    };
    setAddressList([...addressList, newAddress]);
    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
        shape="round"
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {labelConfig.add}
      </Button>

      <Modal
        title="Address Information Setup"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <Form
          form={useForm}
          layout="vertical"
          onFinish={handleAddressSave}
          name="address-info"
        >
          <Row>
            <Divider />

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressTypeId}
                  name={"addressTypeId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressTypeId),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressTypeId,
                      "select",
                    )}
                    options={addressTypeIdData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressOne}
                  name={"addressLine1"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressOne),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressOne,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressTwo}
                  name={"addressLine2"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(
                  //       labelConfig.addressTwo
                  //     ),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressTwo,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.city}
                  name={"city"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.city),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.city)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.country}
                  name={"countryId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.country),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.country,
                      "select",
                    )}
                    options={countryIdData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.stateProvince}
                  name={"stateProvinceId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.stateProvince),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.stateProvince,
                      "select",
                    )}
                    options={stateProvinceIdData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.postalCode}
                  name={"postalCode"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(
                  //       labelConfig.postalCode
                  //     ),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.postalCode,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressStatus}
                  name={"isActive"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressStatus),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.addressStatus}`,
                      "select",
                    )}
                    options={staticConfig.statusData}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />

            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
};
